export default __webpack_public_path__ + "static/media/FOX.113ecdbb.png";